<div class="container py-4" *ngIf="p as prod">
  <div class="row g-4">
    <div class="col-md-6">
      <div class="detail-media">
        <img [src]="prod.images[active]" [alt]="prod.name" class="detail-img">
      </div>

      <div class="thumbs mt-2">
        <img *ngFor="let img of prod.images; let i = index"
             [src]="img" [alt]="prod.name"
             class="thumb" [class.active]="i === active"
             (click)="setActive(i)">
      </div>
    </div>

    <div class="col-md-6">
      <h1 class="h3 mb-2">{{ prod.name }}</h1>
      <p class="text-secondary">{{ prod.shortDesc }}</p>

      <h4 class="mb-3" *ngIf="prod.salePolicy !== 'QUOTE'">
        {{ prod.price | currency:'PEN':'symbol-narrow' }}
      </h4>

      <div class="d-flex flex-wrap gap-2 mb-3">
        <button class="btn btn-pro-outline"
                *ngIf="prod.salePolicy !== 'BUY'"
                (click)="quote.add(prod)">
          <i class="bi bi-clipboard-check"></i><span>Solicitar cotización</span>
        </button>

        <button class="btn btn-pro"
                *ngIf="prod.salePolicy !== 'QUOTE'"
                (click)="cart.add(prod,1)">
          <i class="bi bi-cart-plus"></i><span>Agregar al carrito</span>
        </button>
      </div>

      <section *ngIf="prod.specs?.length">
        <h6>Especificaciones</h6>
        <ul class="small mb-0">
          <li *ngFor="let s of prod.specs">{{ s.key }}: {{ s.value }}</li>
        </ul>
      </section>
    </div>
  </div>
</div>
